import React, { useContext, useState } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import PieChartGraph from "components/Graphs/PieChart";
import NumberFormat from 'react-number-format';
import { FetchAPI } from "api/fetch";
import { useEffect } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { PostAPI } from "api/post.js";
import { loopBackDomain, loopBackPort } from "environment/environment";
import SimpleBarGraph from "components/Graphs/SimpleBarGraph";
import DatePicker from "react-datepicker";
import moment from 'moment'
import "react-datepicker/dist/react-datepicker.css";
import ButtonField from '../components/UI/Button/ButtonField';
import { months,QRDataPacking,QRDataPutAway,QRDataSalesAmbernath,
  QRDataStockTransfer,QRDataReceive,QRDataSales,monthlyProduction2021, 
  monthlyDispatch2021,monthlyProduction2020, 
  monthlyDispatch2020,monthlyProduction2019, 
  monthlyDispatch2019,monthlyProductionDefault, 
  monthlyDispatchDefault } from "../variables/Variables.jsx";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const PageType1 = props => {
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const [usedVsUnusedData, setUsedVsUnusedData] = useState({});
  const [monthWiseIOTDataUpd, setMonthWiseIOTDataUpd] = useState({});
  const [monthWiseProductionData, setMonthWiseProductionData] = useState({});
  const [monthWiseDispatchData, setMonthWiseDispatchData] = useState({});
  const [monthWiseReceiveData, setMonthWiseReceiveData] = useState({});
  const [unUsedQRData, setUnUsedQRData] = useState({});
  const [liveVsNonLiveDataUpd, setLiveVsNonLiveDataUpd] = useState({});
  const [productsCategoriesData, setProductsCategoriesData] = useState({});
  const [stackedGraphData, setStackedGraphData] = useState({});
  const [topProductsData, setTopProductsData] = useState({});
  let objStacked = {};
  let livePercentage = [];
  let nonLivePercentage = [];
  const variables1 = {
    "downloaded": 22685925,
    "availableToDownload": 255835
  }
  const variables2 = {
    "allProducts": 576,
    "liveProducts": 255,
    "nonLiveProducts": 321
  }
  const variables3 = {
    data1: [
      "HDDEO",
      "OEM",
      "MCO",
      "Agri DEO",
      "CNG",
      "Cummins",
      "HDDEO",
      "PCMO",
      "Gear Oil Auto",
      "Industrial Oils",
      "Deo",
      "Exports"
  ],
  data2: [47, 26, 13, 32, 7, 34, 4, 18, 29, 43, 1, 1]
  };
  const variables4 ={
    data1 : [
      "HDDEO",
      "Brake Fluid",
      "Other",
      "OEM",
      "MCO",
      "Agri DEO",
      "CNG",
      "Cummins",
      "HDDEO",
      "PCMO",
      "Gear Oil Auto",
      "Grease",
      "Industrial Oils",
      "Specialty",
      "Deo",
      "Aus32",
      "Exports",
      "AntiFreeze"
    ],
    data2 : [47, 0, 0, 26, 13, 32, 7, 34, 4, 18, 29, 0, 43, 0, 1, 0, 1, 0],
    data3 : [5, 3, 1, 148, 16, 11, 2, 3, 0, 8, 5, 26, 17, 17, 1, 7, 39, 12],
    data4 : [90.38461538461539,
      0,
      0,
      14.942528735632186,
      44.827586206896555,
      74.4186046511628,
      77.77777777777779,
      91.8918918918919,
      100,
      67.23076923076923,
      85.29411764705883,
      0,
      71.66666666666667,
      0,
      50,
      0,
      2.5,
      0
    ],
    data5 : [ 9.615384615384617,
      100,
      100,
      85.0574712643678,
      55.172413793103445,
      25.581395348837212,
      22.22222222222222,
      8.108108108108109,
      0,
      30.76923076923077,
      14.705882352941178,
      100,
      28.33333333333332,
      100,
      50,
      100,
      97.5,
      100
    ]
  }
  let liveCount = variables4.data2.reduce((result, number) => result + number);
  let nonLiveCount = variables4.data3.reduce((result, number) => result + number);
  let sum = liveCount + nonLiveCount;
  let temp =0;
  variables4.data2.map(function(prop, key){
    prop = prop*100;
    prop = prop/liveCount;
    livePercentage.push(prop);
  });
  variables4.data3.map(function(prop, key){

    prop = prop*100;
    prop = prop/nonLiveCount;
    nonLivePercentage.push(prop);
  });
  objStacked = {data1:variables4.data1, data2:livePercentage, data3:nonLivePercentage}
  const variables5 = {
    productName : [
    "CHAMP 4T 20W40 20/0.9 LTR (500216)",
    "CNG SPECIAL 20W50 20/1 LTR (505586)",
    "CHAMP 4T 20W40 20/1 LTR (500213)",
    "FIT 4T 20W40 20/0.9L (506936)",
    "ALL FLEET TC GENUINE 15W40 4/3 LTR (504635)"
    ],
    productQuantity : [2984658, 2160607, 1562507, 1017255, 1011860]
  }
  const customMinDate = new Date('2021-01-01');
  const customMaxDate = new Date('2021-03-31');
  const [startDateFirst, setStartDateFirst] = useState(customMinDate);
  const [endDateFirst, setEndDateFirst] = useState(customMaxDate);
  const includeDatesCustom = [
    new Date('2018-05-03'),
    new Date('2018-05-04'),
    new Date('2018-05-05'),
    new Date('2018-05-06'),
    new Date('2018-05-07'),
    new Date('2018-05-08'),
    new Date('2018-05-09'),
    new Date('2018-05-10'),
    new Date('2018-05-11'),
    new Date('2018-05-12'),
    new Date('2018-05-13')
  ];
  const [startDateSecond, setStartDateSecond] = useState(customMinDate);
  //const [endDateSecond, setEndDateSecond] =  useState(new Date('2018-05-13'));
  const [startDateThird, setStartDateThird] = useState(customMinDate);
  const [endDateThird, setEndDateThird] = useState(customMaxDate);
  const [startDateLiveVsNonLive, setStartDateLiveVsNonLive] = useState(new Date('2018-05-03'));
  const [endDateLiveVsNonLive, setEndDateLiveVsNonLive] = useState(new Date('2018-05-13'));
  const [startDateLiveSKUBreakUp, setStartDateLiveSKUBreakUp] = useState(new Date('2018-05-03'));
  const [endDateLiveSKUBreakUp, setEndDateLiveSKUBreakUp] = useState(new Date('2018-05-13'));
  const [startDateLiveVsNonLiveStacked, setStartDateLiveVsNonLiveStacked] = useState(new Date('2018-05-03'));
  const [endDateLiveVsNonLiveStacked, setEndDateLiveVsNonLiveStacked] = useState(new Date('2018-05-13'));
  const [startDateMonthlyProd, setStartDateMonthlyProd] = useState(customMinDate);
  const [startDateMonthlyDispatch, setStartDateMonthlyDispatch] = useState(customMinDate);
  const [startDateMonthlyReceive, setStartDateMonthlyReceive] = useState(customMinDate);
  const [startDateQRTimeline, setStartDateQRTimeline] = useState(customMinDate);
  let [tempProdData,setTempProdData] = useState();
  let [tempDispatchData,setTempDispatchData] = useState();
 
  useEffect(() => {
    setTempProdData(monthlyProductionDefault);
    setTempDispatchData(monthlyDispatchDefault);
    (async () => {
      if (pageLayoutData != 'undefined') {

        let getURL = pageLayoutData[1].subComponentsItems.usedVsUnused.apiEndPoint;
        let graphDataVal = await FetchAPI(getURL);
        let graphDataValJson = await graphDataVal.json();
        setUsedVsUnusedData(graphDataValJson.data);
        let getURL1 = pageLayoutData[2].subComponentsItems.monthWiseIOTData.apiEndPoint;
        let graphDataVal1 = await FetchAPI(getURL1);
        let graphDataValJson1 = await graphDataVal1.json();
        setMonthWiseIOTDataUpd(graphDataValJson1.data);
        let getURL2 = pageLayoutData[13].subComponentsItems.monthWiseData.apiEndPoint;
        let graphDataVal2 = await FetchAPI(getURL2);
        let graphDataValJson2 = await graphDataVal2.json();
        setMonthWiseProductionData(graphDataValJson2.data);
        let getURL3 = pageLayoutData[14].subComponentsItems.dispatchMonthlyData.apiEndPoint;
        let graphDataVal3 = await FetchAPI(getURL3);
        let graphDataValJson3 = await graphDataVal3.json();
        setMonthWiseDispatchData(graphDataValJson3.data);
        let getURL4 = pageLayoutData[15].subComponentsItems.receiveMonthlyData.apiEndPoint;
        let graphDataVal4 = await FetchAPI(getURL4);
        let graphDataValJson4 = await graphDataVal4.json();
        setMonthWiseReceiveData(graphDataValJson4.data);
      }

    })()
  }, [pageLayoutData])

  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);

   useEffect(() => {
   (async () => {
       let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
       const payload = {
         pageTypeID: 1,
         featureID: 1
       };

       cookies.set('feature_id', 1, { path: '/' });
       await setGlobalLoadIndicator('1');
       let response = await PostAPI(url, payload);
       await setFeatureBlueprint(response);
       await setGlobalLoadIndicator('2');
     })()
   }, [])

  let commonParameters = {
    customer_id: cookies.get('customer_id'),
    user_id: cookies.get('user_id'),
  }

  const filterDataFirst = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const startDateFirstUpd = moment(startDateFirst).format("YYYY-MM-DD");
    const endDateFirstUpd = moment(endDateFirst).format("YYYY-MM-DD");
    const getURL = pageLayoutData[1].subComponentsItems.usedVsUnused.apiEndPoint + '?start_date=' + startDateFirstUpd + '&end_date=' + endDateFirstUpd;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setUsedVsUnusedData(filteredDataJson.data);
  }
  const filterDataSecond = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const startDateSecondUpd = moment(startDateSecond).format("YYYY");
    const getURL = pageLayoutData[2].subComponentsItems.monthWiseIOTData.apiEndPoint + '?year=' + startDateSecondUpd;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setMonthWiseIOTDataUpd(filteredDataJson.data);
  }
  const filterDataThird = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const startDateThirdUpd = moment(startDateThird).format("YYYY-MM-DD");
    const endDateThirdUpd = moment(endDateThird).format("YYYY-MM-DD");
    const getURL = pageLayoutData[1].subComponentsItems.usedVsUnused.apiEndPoint + '?start_date=' + startDateThirdUpd + '&end_date=' + endDateThirdUpd;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setUsedVsUnusedData(filteredDataJson.data);
  }
  const filterDataLiveVsNonLive = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const getURL = pageLayoutData[1].subComponentsItems.levelIdsEndPoint + '?start_date=' + startDateFirst + '&end_date=' + endDateFirst;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setLiveVsNonLiveDataUpd(filteredDataJson.data);
  }
  const filterDataLiveSKUBreakUp = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const getURL = pageLayoutData[1].subComponentsItems.levelIdsEndPoint + '?start_date=' + startDateFirst + '&end_date=' + endDateFirst;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setProductsCategoriesData(filteredDataJson.data);
  }
  const filterDataLiveVsNonLiveStacked = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const getURL = pageLayoutData[1].subComponentsItems.levelIdsEndPoint + '?start_date=' + startDateFirst + '&end_date=' + endDateFirst;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setStackedGraphData(filteredDataJson.data);
  }
  const filterDataMonthlyProd = async (e) => {
    e.preventDefault();
    let year=moment(startDateMonthlyProd).format('YYYY');
    if(year==2019)
    setTempProdData(monthlyProduction2019);
    else if(year == 2020)
    setTempProdData(monthlyProduction2020);
    else if(year == 2021)
    setTempProdData(monthlyProduction2021);
    else
    setTempProdData(monthlyProduction2021);
  }
  const filterDataMonthlyDispatch = async (e) => {
    let year=moment(startDateMonthlyDispatch).format('YYYY');
    if(year == 2019)
    setTempDispatchData(monthlyDispatch2019);
    else if(year == 2020)
    setTempDispatchData(monthlyDispatch2020);
    else if(year == 2021){
    setTempDispatchData(monthlyDispatch2021);
    }
    else
    setTempDispatchData(monthlyDispatch2021); 
  }
  const filterDataMonthlyReceive = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const startDateMonthlyReceiveUpd = moment(startDateMonthlyReceive).format("YYYY");
    const getURL = pageLayoutData[15].subComponentsItems.receiveMonthlyData.apiEndPoint + '?year=' + startDateMonthlyReceiveUpd;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setMonthWiseReceiveData(filteredDataJson.data);
  }



  return (
  
    (pageLayoutData != 'undefined') ?
      <div className="content">
      
        <Grid fluid>
      
          <Row>
            <Col md={12}>
            {window.location.pathname == '/admin/dashboard' ? 
            <div>
              <Row>
                <Col md={6}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[1].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[1].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[1].category : 'demo'}
                    content={
                      <>
                        <div style={{ float: 'right' }}>
                          <DatePicker
                            className="form-control"
                            selected={startDateFirst}
                            onChange={date => setStartDateFirst(date)}
                            selectsStart
                            startDate={startDateFirst}
                            endDate={endDateFirst}
                            minDate={customMinDate}
                            maxDate={customMaxDate}
                          />
                          <DatePicker
                            className="form-control"
                            selected={endDateFirst}
                            onChange={date => setEndDateFirst(date)}
                            selectsEnd
                            startDate={startDateFirst}
                            endDate={endDateFirst}
                            minDate={startDateFirst}
                            maxDate={customMaxDate}
                          />
                          <ButtonField color="info" submit={filterDataFirst} BName="Filter" />
                        </div>
                        {<PieChartGraph totalAllocated={pageLayoutData[1].subComponentsItems.usedVsUnused} updatedData={usedVsUnusedData} />}
                      </>
                    }
                    legend={
                      <>
                        <button type="button" style={{ borderRadius: '15px', fontWeight: '1000' }} className="btn btn-outline-primary btn-rounded waves-effect">
                          {pageLayoutData[1].subComponentsItems.legends.firstButton}: <NumberFormat displayType={'text'} thousandSeparator={true} thousandsGroupStyle="lakh" value={usedVsUnusedData.usedStatus} />
                        </button>
                        <button type="button" style={{ borderRadius: '15px', fontWeight: '1000' }} className="btn btn-outline-primary btn-rounded waves-effect">
                          {pageLayoutData[1].subComponentsItems.legends.secondButton}: <NumberFormat displayType={'text'} thousandSeparator={true} thousandsGroupStyle="lakh" value={(usedVsUnusedData.totalAllocated - usedVsUnusedData.usedStatus)} />
                        </button>

                      </>
                    }
                  />
                </Col>
                <Col md={6}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[3].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[3].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[3].category : 'demo'}
                    content={
                      <>
                        <div style={{ float: 'right' }}>
                          <DatePicker
                            className="form-control"
                            selected={startDateThird}
                            onChange={date => setStartDateThird(date)}
                            selectsStart
                            startDate={startDateThird}
                            endDate={endDateThird}
                            minDate={customMinDate}
                            maxDate={customMaxDate}
                          />
                          <DatePicker
                            className="form-control"
                            selected={endDateThird}
                            onChange={date => setEndDateThird(date)}
                            selectsEnd
                            startDate={startDateThird}
                            endDate={endDateThird}
                            minDate={startDateThird}
                            maxDate={customMaxDate}
                          />
                          <ButtonField color="info" submit={filterDataThird} BName="Filter" />
                        </div>
                        {<PieChartGraph totalAllocated={pageLayoutData[3].subComponentsItems.UnusedQR} updatedData={usedVsUnusedData} />}
                      </>
                    }
                    legend={
                      <>
                        <button type="button" style={{ borderRadius: '15px', fontWeight: '1000' }} className="btn btn-outline-primary btn-rounded waves-effect">
                          {pageLayoutData[3].subComponentsItems.legends.firstButton}: <NumberFormat displayType={'text'} thousandSeparator={true} thousandsGroupStyle="lakh" value={(parseInt(usedVsUnusedData.downloadedStatus) + parseInt(usedVsUnusedData.issuedStatus))} />
                        </button>
                        <button type="button" style={{ borderRadius: '15px', fontWeight: '1000' }} className="btn btn-outline-primary btn-rounded waves-effect">
                          {pageLayoutData[3].subComponentsItems.legends.secondButton}: <NumberFormat displayType={'text'} thousandSeparator={true} thousandsGroupStyle="lakh" value={(usedVsUnusedData.totalAllocated - usedVsUnusedData.usedStatus)} />
                        </button>

                      </>
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[2].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[2].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[2].category : 'demo'}
                    content={
                      <>
                        <div style={{ float: 'right' }}>
                          <DatePicker
                            selected={startDateSecond}
                            className="form-control"
                            onChange={date => setStartDateSecond(date)}
                            showYearPicker
                            dateFormat="yyyy"
                            minDate={(new Date('2018'))}
                            maxDate={(new Date('2019'))}
                          />
                          <ButtonField color="info" submit={filterDataSecond} BName="Filter" />
                        </div>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[2].subComponentsItems.monthWiseIOTData}
                          updatedData={monthWiseIOTDataUpd}
                        />}
                      </>
                    }
                  />
                </Col>
              </Row>

            </div> : ''}
  {window.location.pathname == '/admin/materialLiveVsNonlive' ? 
  <div> 
              <Row>
                <Col md={6}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[5].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[5].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[5].category : 'demo'}
                    content={
                      <>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[5].subComponentsItems.liveVsNonLiveData}
                          updatedData={variables2}
                      /> }
                      </>
                    }
                  />
                </Col>
                <Col md={6}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[11].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[11].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[11].category : 'demo'}
                    content={
                      <>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[11].subComponentsItems.topFiveProducts}
                          updatedData={variables5}
                        />}
                       
                      </>
                    }
                  />
                </Col>
              </Row>
  </div> : ''}    
  {window.location.pathname == '/admin/categoryLiveVsNonlive' ?    
  <div>           
              <Row>
                <Col md={12}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[7].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[7].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[7].category : 'demo'}
                    content={
                      <>
                          {pageLayoutData[7].subComponentsItems.productsCategories ?
                          <PieChartGraph totalAllocated={pageLayoutData[7].subComponentsItems.productsCategories} updatedData={variables3} />
                           : 
                           <BeatLoader size={15} margin={3} color={"#36d7b7"} />
                           } 
                      </>
                    }
                    legend={
                      <>
                        <button type="button" style={{ borderRadius: '15px', fontWeight: '1000' }} className="btn btn-outline-primary btn-rounded waves-effect">
                          {pageLayoutData[7].subComponentsItems.legends.button}: {liveVsNonLiveDataUpd.liveProducts}
                        </button>

                      </>
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[9].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[9].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[9].category : 'demo'}
                    content={
                      <>
                           {pageLayoutData[9].subComponentsItems.totalVsLiveDataStackedGraph ?
                          <SimpleBarGraph totalAllocated={pageLayoutData[9].subComponentsItems.totalVsLiveDataStackedGraph}
                          updatedData={variables4}
                        />
                           : 
                           <BeatLoader size={15} margin={3} color={"#36d7b7"} />
                           }
                        
                         <table className="table">
                          {pageLayoutData[9].subComponentsItems.totalVsLiveDataStackedGraph ?
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }}>Category Name</th>
                                {variables4.data1.map((prop, key) => {
                                  return <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                                {<th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }}>Total</th>}
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }}>Live</th>
                                {variables4.data2.map((prop, key) => {
                                  return <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                                <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }}>{variables4.data2.reduce((result, number) => result + number)}</th>
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }}>Non-Live</th>
                                {variables4.data3.map((prop, key) => {
                                  return <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                                <th style={{ fontWeight: '1000', fontSize: '10px', color: '#000' }}>{variables4.data3.reduce((result, number) => result + number)}</th>
                              </tr>
                            </tbody>
                            : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}
                        </table>
                      </>
                    }
                  />
                </Col>
              </Row>
</div> : ''}             
  {window.location.pathname == '/admin/monthlyAnalysis' ?    
  <div>
              <Row>
                <Col md={12}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[13].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[13].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[13].category : 'demo'}
                    content={
                      <>
                        <div style={{ float: 'right' }}>
                          <DatePicker
                            className="form-control"
                            selected={startDateMonthlyProd}
                            onChange={date => setStartDateMonthlyProd(date)}
                            minDate={(new Date('2019'))}
                            maxDate={(new Date('2021'))}
                            showYearPicker
                            dateFormat="yyyy"
                          />
                          <ButtonField color="info" submit={filterDataMonthlyProd} BName="Filter" />
                        </div>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[13].subComponentsItems.monthWiseData}
                          updatedData={tempProdData}
                        />}
                        <div>
                          <table className="table">
                            {(Object.keys(monthWiseProductionData).length !== 0) ?
                              <tbody>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>Month</th>
                                  {tempProdData.months.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop}</th>;
                                  })}
                                </tr>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>IOT Count</th>
                                  {tempProdData.monthWiseIOTCount.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</th>;
                                  })}
                                </tr>
                              </tbody>
                              : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}
                          </table>
                        </div>
                      </>
                    }
                  />
                </Col>
                <Col md={3}></Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[14].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[14].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[14].category : 'demo'}
                    content={
                      <>
                        <div style={{ float: 'right' }}>
                          <DatePicker
                            className="form-control"
                            selected={startDateMonthlyDispatch}
                            onChange={date => setStartDateMonthlyDispatch(date)}
                            showYearPicker
                            minDate={(new Date('2019'))}
                            maxDate={(new Date('2021'))}
                            dateFormat="yyyy"
                          />
                          <ButtonField color="info" submit={filterDataMonthlyDispatch} BName="Filter" />
                        </div>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[14].subComponentsItems.dispatchMonthlyData}
                          updatedData={tempDispatchData}
                        />}
                        <div>
                          <table className="table">
                            {(Object.keys(monthWiseDispatchData).length !== 0) ?
                              <tbody>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>Month</th>
                                  {tempDispatchData.months.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop}</th>;
                                  })}
                                </tr>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>IOT Count</th>
                                  {tempDispatchData.monthWiseIOTCount.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</th>;
                                  })}
                                </tr>
                              </tbody>
                              : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}
                          </table>
                        </div>
                      </>
                    }
                  />
                </Col>
                <Col md={3}></Col>
              </Row>
</div> : ''}
              
          
          {/* Coverage & Distribution - QR Codes */}

          {/* QR Timeline Graph */}
          {window.location.pathname == '/admin/qrTimeline' ?    
  <div>
              <Row>
                <Col md={12}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[17].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[17].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[17].category : 'demo'}
                    content={
                      <>
                       <div style={{ float: 'right' }}>
                          <DatePicker
                            selected={startDateQRTimeline}
                            className="form-control"
                            onChange={date => setStartDateQRTimeline(date)}
                            showYearPicker
                            dateFormat="yyyy"
                            minDate={(new Date('2021'))}
                            maxDate={(new Date('2021'))}
                          />
                          <ButtonField color="info" BName="Filter" />
                        </div>
                       
                        <table className="table" style={{marginTop:'5%'}}>
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }}>Month</th>
                                {months.map((prop, key) => {
                                  return <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }}>Production</th>
                                {QRDataPacking.map((prop, key) => {
                                  return <th style={{  fontSize: '13px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }}>Put Away</th>
                                {QRDataPutAway.map((prop, key) => {
                                  return <th style={{ fontSize: '13px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }}>Sales-Ambernath</th>
                                {QRDataSalesAmbernath.map((prop, key) => {
                                  return <th style={{ fontSize: '13px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }}>Stock Transfer-Ambernath</th>
                                {QRDataStockTransfer.map((prop, key) => {
                                  return <th style={{ fontSize: '13px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }}>Receive</th>
                                {QRDataReceive.map((prop, key) => {
                                  return <th style={{ fontSize: '13px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                              </tr>
                              <tr>
                                <th style={{ fontWeight: '1000', fontSize: '13px', color: '#000' }}>Sales</th>
                                {QRDataSales.map((prop, key) => {
                                  return <th style={{ fontSize: '13px', color: '#000' }} key={key}>{prop}</th>;
                                })}
                              </tr>
                            </tbody>
                        </table>
                      </>
                    }
                  />
                </Col>
              </Row>

            </div> : ''}  
            </Col>
          </Row>
        </Grid>
      </div>
      : <div className="content">
        <Grid fluid>
          <div className="text-center" style={{ margin: "200px" }}><BeatLoader size={15} margin={3} color={"#3C423C"} /></div>
        </Grid>
      </div>
  );
}

export default PageType1;

